import { Breadcrumbs, Divider, Group, GroupProps, Text } from "@mantine/core"
import { useRouterState } from "@tanstack/react-router"
import { Link } from "../link"
import { useBreakpoints } from "../../utils/use-breakpoints"
import { FileRoutesByTo } from "@/routeTree.gen"
import { NavigateBackButton } from "@components/NavigateBackButton"

export interface NavGroupProps extends GroupProps {
  crumbOverride?:
    ((params?: Record<string, unknown>) => React.ReactElement) | undefined
}

// If your crumb is a complex component, or dependant on queryClient Data,
// you need to invalidate the router every time the data changes, so that the components can update.
// e.g. if a crumb depends on personData because we want the userName to be displayed
// we need to use this:

// const router = useRouter()

// React.useEffect(() => {
//   router.invalidate()
// }, [person])

export function NavGroup({ crumbOverride, ...navGroupProps }: NavGroupProps) {
  const { matches } = useRouterState({
    select: (s) => ({ matches: s.matches, search: s.location.search }),
  })

  const { xs } = useBreakpoints()

  const lastParams = matches[matches.length - 1]?.params

  const crumbs = matches
    .slice(2)
    .filter((x, index, slicedMatches) => {
      return (
        x.pathname !== slicedMatches[index - 1]?.pathname + "/" &&
        x.context.getTitle
      )
    })
    .map(({ pathname, context }, index, slicedAndFilteredMatches) =>
      index === slicedAndFilteredMatches.length - 1 ? (
        crumbOverride ? (
          <React.Fragment key={pathname}>
            {crumbOverride(lastParams)}
          </React.Fragment>
        ) : (
          <Text key={pathname} fw={500} size="xl" truncate={"end"}>
            {context?.getTitle && context?.getTitle()}
          </Text>
        )
      ) : (
        <Link
          truncate={"end"}
          key={pathname}
          navigateOptions={{ to: pathname as keyof FileRoutesByTo }}
          fw={500}
          linkText={
            context.getTitle === undefined
              ? "Kein Titel fuer " + pathname
              : context.getTitle()
          }
          size="xl"
        />
      )
    )

  return (
    <Group {...navGroupProps}>
      {crumbs.length > 1 || Object.keys(lastParams ?? {}).length > 0 ? (
        <>
          <NavigateBackButton />
          <Divider orientation="vertical" />
        </>
      ) : null}
      <Breadcrumbs
        flex={1}
        // w={"100%"}
        separator=">"
        separatorMargin="sm"
        styles={{
          breadcrumb: { lineHeight: 1.5 },
        }}
      >
        {xs ? crumbs[crumbs.length - 1] : crumbs}
      </Breadcrumbs>
    </Group>
  )
}
